import React, { useState } from 'react';
import styles from './SelectionGroup.module.scss';
import HelpButton from '../../atoms/HelpButton/HelpButton';

export interface SelectionOption {
  value: string;
  label: string;
  description: string;
  image?: string;
  accordionContent?: React.ReactNode;
  disabled?: boolean;
  disabledMessage?: string;
}

interface SelectionGroupProps {
  title: string;
  name?: string;
  options: SelectionOption[];
  selectedValue: string;
  onChange: (value: string) => void;
  showQuestionIcon?: boolean;
  helpText?: string;
  isNested?: boolean;
}

const SelectionGroup: React.FC<SelectionGroupProps> = ({
  title,
  name,
  options,
  selectedValue,
  onChange,
  showQuestionIcon,
  helpText,
  isNested = false,
}) => {
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);

  const handleSelectionChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    value: string,
  ) => {
    onChange(value);
  };

  return (
    <div className={`${styles.selectionGroup} ${isNested ? styles.nested : ''}`}>
      <div className={styles.titleContainer}>
        <h3 className={styles.title}>{title}</h3>
        {showQuestionIcon && helpText && (
          <HelpButton helpText={helpText} />
        )}
      </div>
      <div className={styles.optionsContainer}>
        {options.map((option) => (
          <div key={option.value} className={styles.optionWrapper}>
            <label
              className={`${styles.option} ${option.disabled ? styles.disabled : ''}`}
              aria-disabled={option.disabled}
            >
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={selectedValue === option.value}
                onChange={(e) => !option.disabled && handleSelectionChange(e, option.value)}
                className={styles.radioInput}
                disabled={option.disabled}
              />
              <span className={styles.customRadio} />
              {option.image && (
                <img
                  src={option.image}
                  alt={option.label}
                  className={styles.optionImage}
                />
              )}
              <div className={styles.optionDetails}>
                <span className={styles.optionLabel}>{option.label}</span>
                {option.description && (
                  <p className={styles.optionDescription}>{option.description}</p>
                )}
                {/* 非活性メッセージ表示 */}
                {option.disabled && option.disabledMessage && (
                  <p className={styles.disabledMessage}>{option.disabledMessage}</p>
                )}
              </div>
            </label>
            {selectedValue === option.value && option.accordionContent && (
              <div className={styles.accordionContent}>
                {option.accordionContent}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectionGroup; 